import type { LessonSummary } from '../api/content.types';
import type { LessonStepParams } from '../screens/lesson/types';

export type LessonStepKey = 'kanaIntro' | 'kanaQuiz' | 'vocabIntro' | 'vocabQuiz' | 'grammar' | 'practice' | 'complete';

export interface LessonSession extends LessonStepParams {
  steps: LessonStepKey[];
  /** Vị trí hiện tại trong `steps`. */
  index: number;
}

/**
 * Chuỗi bước của 1 bài — khớp điều hướng của HocStack bên mobile:
 * PRACTICE → Practice → Complete; KANA → Intro → Quiz → Complete;
 * VOCAB → Intro → Quiz → Complete; còn lại (GRAMMAR) → GrammarLesson → Complete.
 */
export function stepsForLesson(lesson: LessonSummary): LessonStepKey[] {
  if (lesson.mode === 'PRACTICE') return ['practice', 'complete'];
  if (lesson.track === 'KANA') return ['kanaIntro', 'kanaQuiz', 'complete'];
  if (lesson.track === 'VOCAB') return ['vocabIntro', 'vocabQuiz', 'complete'];
  return ['grammar', 'complete'];
}

export function startSession(unitName: string, lesson: LessonSummary): LessonSession {
  return { lessonId: lesson.id, unitName, lessonName: lesson.name, steps: stepsForLesson(lesson), index: 0 };
}
